module.exports = __webpack_public_path__ + "static/media/11.1a11cdb9.svg";